import type { AnalyticsSink } from './AnalyticsSink'

const LOG_KEY = 'cybertales.analytics.log'
const MAX_ENTRIES = 500

// Zero-cost stand-in for Application Insights (Document 11 §9). Writes a
// bounded local event log; AppInsightsAnalyticsSink (P5) replaces this
// behind the same AnalyticsSink interface.
export class LocalAnalyticsSink implements AnalyticsSink {
  track(eventName: string, properties: Record<string, unknown> = {}) {
    const entry = { eventName, properties, at: new Date().toISOString() }
    try {
      const raw = localStorage.getItem(LOG_KEY)
      const log = raw ? (JSON.parse(raw) as unknown[]) : []
      log.push(entry)
      while (log.length > MAX_ENTRIES) log.shift()
      localStorage.setItem(LOG_KEY, JSON.stringify(log))
    } catch {
      // localStorage unavailable (e.g. private browsing) — analytics is
      // best-effort in zero-cost mode, never blocks the UI.
    }
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', eventName, properties)
    }
  }
}
